const FIRM_TYPES_BY_PREFIX = { BT: 'BankTrust', FO: 'Investor', EF: 'Foundation', RIA: 'RiaInvestor' };

// related_id arrives either as a display id ("BT-123", from the firm search) or as a bare id
// next to related_type (from the relationships endpoint); both resolve to "BankTrust-123".
export const relatedEntityKey = ({ related_id, related_type } = {}) => {
    if (related_id === undefined || related_id === null || related_id === '') return null;

    const [prefix, id] = String(related_id).split('-');
    if (FIRM_TYPES_BY_PREFIX[prefix] && id) return `${FIRM_TYPES_BY_PREFIX[prefix]}-${id}`;

    return `${related_type || 'BankTrust'}-${related_id}`;
};

export const isRelatedEntityListed = (relatedEntities, candidate, exceptIndex) => {
    const key = relatedEntityKey(candidate);

    return key !== null && relatedEntities.some((entity, index) =>
        index !== exceptIndex && !entity?._destroy && relatedEntityKey(entity) === key
    );
};

export const duplicatedRelatedEntityMessage = (name) =>
    `${name || 'This entity'} is already listed. Add the relationship to its existing row instead.`;
